export const LOAD_SETTINGS_ACTION_TYPES = {
  CHANGE_LOAD_DATE: 'settings/CHANGE_LOAD_DATE',
  RESET_LOAD_DATE: 'settings/RESET_LOAD_DATE',
  CHANGE_LOAD_VERIFICATION: 'settings/CHANGE_LOAD_VERIFICATION',
  RESET_LOAD_VERIFICATION: 'settings/RESET_LOAD_VERIFICATION',
};

export const changeLoadDate = (date) => {
  return {
    type: LOAD_SETTINGS_ACTION_TYPES.CHANGE_LOAD_DATE,
    payload: date,
  };
};

export const resetLoadDate = {
  type: LOAD_SETTINGS_ACTION_TYPES.RESET_LOAD_DATE,
};

export const changeLoadVerification = (params) => {
  return {
    type: LOAD_SETTINGS_ACTION_TYPES.CHANGE_LOAD_VERIFICATION,
    payload: params,
  };
};

export const resetLoadVerification = {
  type: LOAD_SETTINGS_ACTION_TYPES.RESET_LOAD_VERIFICATION,
};
